import React from "react";

import PropTypes from "prop-types";

import { Button, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AddButton = ({ title = "", icon = "plus", onClick = () => {} }) => (
  <Button
    rounded
    color={icon === "plus" ? "success" : "danger"}
    size="small"
    style={{ padding: 0, width: 20, height: 20 }}
    title={title}
    onClick={onClick}
  >
    <Icon>
      <FontAwesomeIcon icon={icon} size="md" />
    </Icon>
  </Button>
);

AddButton.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
};
export default AddButton;
